<template>
    <div class="search-form-pagination">
        <el-pagination
            :page-size="pageSize"
            :total="total"
            :current-page="currentPage"
            :hide-on-single-page="hideSingle"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            background
            layout="total, prev, pager, next, sizes, jumper"
            ref="pagination"
        ></el-pagination>
    </div>
</template>

<script>
export default {
  name: 'page-component',
  props: {
    total: 0,
    currentPage: {
      type: Number,
      default: 1
    },
    hideSingle: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageClickCtrl: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerPageSize: this.pageSize,
      pageSizes: [10, 20, 50, 100, 200, 300],
      bgWidth: 540,
      bgHeight: 32
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('pageSizeChange', val * 1)
    },
    handleCurrentChange(val) {
      this.$emit('currentPageChange', val)
    },
    pageCtrlClick() {
      this.$emit('pageCtrlClick')
    }
  },
  watch: {
    total() {
      const that = this
      this.$nextTick(() => {
        that.bgWidth = that.$refs.pagination.$el.offsetWidth - 100
        that.bgHeight = that.$refs.pagination.$el.offsetHeight
      })
    },
    innerPageSize(val) {
      // this.$emit('pageSizeChange', val * 1)
    },
    pageSize(val) {
      this.innerPageSize = val
    }
  }
}
</script>

<style lang="scss">

// .page-component {
//     padding: 8px 0;
//     overflow: hidden;
//     position: relative;
//     .el-select {
//         .el-input {
//             width: 80px;
//             .el-input__inner {
//                 width: 80px;
//                 height: 32px;
//                 text-align: left;
//                 border-radius: 2px;
//             }
//             .el-input__suffix {
//                 border-left: 1px solid #ccc;
//                 transform: scale(1);
//                 line-height: 30px;
//             }
//         }
//     }
//     .el-pagination {
//         font-weight: normal;
//     }
//     .el-pagination__editor,
//     .el-pagination .el-select .el-input {
//         margin: 0 8px;
//     }
//     .el-pagination.is-background .btn-prev,
//     .el-pagination.is-background .btn-next,
//     .el-pagination.is-background .el-pager li {
//         margin: 0;
//         background: #fff;
//         border-radius: 0;
//         height: 32px;
//         line-height: 30px;
//         font-size: 14px;
//         color: #595959;
//         font-weight: normal;
//     }
//     .el-pagination.is-background .btn-prev {
//         border: 1px solid #d9d9d9;
//         border-right: 0;
//         border-top-left-radius: 2px;
//         border-bottom-left-radius: 2px;
//         margin-left: 8px;
//     }
//     .el-pagination.is-background .btn-next {
//         border: 1px solid #d9d9d9;
//         border-top-right-radius: 2px;
//         border-bottom-right-radius: 2px;
//     }
//     .el-pagination.is-background .el-pager li {
//         border-top: 1px solid #d9d9d9;
//         border-bottom: 1px solid #d9d9d9;
//         border-left: 1px solid #d9d9d9;
//     }
//     .el-pagination.is-background .el-pager li:not(.disabled).active {
//         background: #f2f9ff;
//         color: #178cff;
//         border: 1px solid #178cff;
//     }
//     .el-pagination span:not([class*='suffix']),
//     .el-pagination button {
//         height: 32px;
//         line-height: 33px;
//     }
//     .el-pagination__editor.el-input .el-input__inner {
//         height: 32px;
//         border-radius: 2px;
//     }
// }
</style>
